var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"split-bar",class:[_vm.position === 'left'? 'split-bar-left': 'split-bar-right'],on:{"click":_vm.handleClick}},[(_vm.position === 'left')?_c('el-icon',{class:_vm.showBar? 'el-icon-arrow-left': 'el-icon-arrow-right'}):_c('el-icon',{class:_vm.showBar? 'el-icon-arrow-right': 'el-icon-arrow-left'})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }